/**
 * 轻量 App「指挥指令」前线消息：坐标方形气泡
 */
import mapboxgl from 'mapbox-gl';
import { toMapLngLat, getActiveBasemapIdForCoord } from './basemapCoord';

const NORMAL_BUBBLE_MS = 14000;

/**
 * 在队员坐标处创建方形气泡（普通消息）
 * @returns {{ marker: mapboxgl.Marker, remove: () => void } | null}
 */
export function showFieldMessageBubbleOnMap(map, message, options = {}) {
  if (!map || !message) return null;
  const lng = Number(message.longitude ?? message.last_longitude);
  const lat = Number(message.latitude ?? message.last_latitude);
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null;

  const display = toMapLngLat(lng, lat, getActiveBasemapIdForCoord(map), map) || [lng, lat];
  const name = message.name || '队员';
  const text = String(message.text || '').slice(0, 80);

  const el = document.createElement('div');
  el.className = 'zhxt-field-msg-bubble';
  el.style.cssText = [
    'max-width:160px',
    'min-width:72px',
    'padding:6px 8px',
    'background:#fff8e1',
    'color:#333',
    'border:1px solid #f0c36d',
    'border-radius:4px',
    'box-shadow:0 2px 8px rgba(0,0,0,.22)',
    'font-size:11px',
    'line-height:1.35',
    'cursor:pointer',
    'pointer-events:auto',
    'white-space:normal',
    'word-break:break-word'
  ].join(';');
  el.innerHTML = `<div style="font-weight:700;color:#b45309;margin-bottom:2px">${escapeHtml(name)}</div>`
    + `<div>${escapeHtml(text)}</div>`;

  const marker = new mapboxgl.Marker({
    element: el,
    anchor: 'bottom',
    pitchAlignment: 'viewport',
    rotationAlignment: 'viewport',
    offset: [0, -8]
  })
    .setLngLat(display)
    .addTo(map);

  const remove = () => {
    try { marker.remove(); } catch (_) { /* ignore */ }
    if (options.onRemove) options.onRemove();
  };

  el.addEventListener('click', (e) => {
    e.stopPropagation();
    try { options.onClick?.(message); } catch (_) { /* ignore */ }
    remove();
  });

  // ttlMs === 0：不自动消失（重要消息）
  const ttl = options.ttlMs != null ? options.ttlMs : NORMAL_BUBBLE_MS;
  const timer = ttl > 0 ? setTimeout(remove, ttl) : null;

  return {
    marker,
    remove: () => {
      if (timer) clearTimeout(timer);
      remove();
    }
  };
}

function escapeHtml(s) {
  return String(s || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
